import { cn } from '@/lib/utils/cn';
import FAQ, { type FAQItem } from 'lib/components/ui/faq';

const faqData: FAQItem[] = [
  {
    id: 'when-to-use',
    question: 'Quand avoir recours à nos services ?',
    answer: `Vous décrochez un mandat, mais :

- Vous connaissez mal le poste ou le secteur, votre base de candidat n'est pas adaptée
- Vous traversez une période de forte activité et vous sentez dépassé par la charge de travail
- Le poste est complexe à pourvoir, les délais sont particulièrement serrés
- La perspective de passer une semaine sur LinkedIn puis au téléphone à essayer de convaincre des candidats indécis ne vous enchante guère`,
    category: 'General',
  },
  {
    id: 'hunteed-vs-headlinker',
    question: 'Quelle est la différence entre Hunteed et Headlinker ?',
    answer: `**Hunteed** est une plateforme de recrutement qui aide les entreprises à gérer leurs recrutements en Europe en offrant une solution digitale et l'expertise de milliers de cabinets de recrutement.

**Headlinker**, en revanche, est une plateforme de collaboration réservée aux professionnels du recrutement, permettant aux recruteurs de publier leurs annonces, de fixer des primes pour les recruteurs qui leur trouveront le bon candidat, et d'accéder à une liste d'offres confidentielles pour proposer leurs meilleurs candidats.

En somme, Hunteed est destiné aux entreprises qui cherchent à externaliser leurs recrutements, tandis que Headlinker est destiné aux professionnels du recrutement qui cherchent à trouver des candidats pour leur mission ou place ceux qui ne souhaitent pas travailler avec leurs clients.`,
    category: 'Comparaison',
  },
  {
    id: 'muzzo-vs-headlinker',
    question: 'Quelle est la différence entre Muzzo et Headlinker ?',
    answer: `**Muzzo** et **Headlinker** sont deux plateformes de recrutement, mais elles servent des publics différents et ont des modèles opérationnels distincts.

**Muzzo** est conçu pour les employeurs qui cherchent à embaucher rapidement et efficacement. Il connecte les employeurs avec des chasseurs de tête et centralise le processus de recrutement, offrant une réception rapide de candidatures qualifiées et une garantie de 3 mois sur les recrutements.

En revanche, **Headlinker** est une plateforme destinée aux recruteurs. Elle leur permet de collaborer, de partager des primes pour les placements réussis, et d'accéder à des offres confidentielles, créant ainsi un réseau gagnant/gagnant pour les professionnels du recrutement.`,
    category: 'Comparaison',
  },
  {
    id: 'pricing',
    question: 'Combien coûte Headlinker ?',
    answer: `**Headlinker** est une plateforme **soumise à un fee d'entrée** pour les professionnels du recrutement. Vous pouvez publier vos annonces, accéder à une liste d'offres confidentielles et proposer vos meilleurs candidats sans frais d'inscription ou d'utilisation.

La plateforme fonctionne sur un modèle de paiement au succès, ce qui signifie que vous ne payez que lorsque vous trouvez le bon candidat pour une offre. Lorsque vous publiez une annonce, vous fixez la prime que vous verserez au recruteur qui vous trouvera le bon candidat.

Celle-ci est divisée en 2 :
- À la prise de fonction
- À la fin de la période d'essai

Headlinker prend **20%** sur ce montant, 10% à chaque recruteur`,
    category: 'Prix',
  },
  {
    id: 'prime-example',
    question: 'Exemple de partage de prime',
    answer: `Je poste une mission pour un Directeur commercial et je suis prêt à donner une prime de 2000€ à la prise de poste et 3000€ à la fin de la période d'essai.

- Le recruteur ayant placé le candidat paye 5000€ au recruteur ayant proposé le candidat
- Les 2 recruteurs payent 500€ à Headlinker`,
    category: 'Prix',
  },
];

export type AppFAQProps = {
  variant?: 'accordion' | 'cards' | 'minimal';
  layout?: 'single' | 'columns';
  searchable?: boolean;
  showCategories?: boolean;
  defaultOpen?: string[];
  className?: string;
};

export default function AppFAQ({
  variant = 'accordion',
  layout = 'single',
  searchable = false,
  showCategories = false,
  defaultOpen = [],
  className,
}: AppFAQProps) {
  return (
    <FAQ
      faqs={faqData}
      variant={variant}
      layout={layout}
      searchable={searchable}
      showCategories={showCategories}
      defaultOpen={defaultOpen}
      className={cn(' max-w-3xl mx-auto', className)}
    />
  );
}
